interface IProps {
  color?: string;
}

const HorizontalDivider: React.FC<IProps> = () => {
  return <div className="my-4 w-full border-b-2 border-gray-500"></div>;
};

export default HorizontalDivider;
